import { fetchHandler, fetchHandlerForm } from "../Handler/Handler";


export const POSTVendor = async (slugname, data) => {
    try {
        const response = await fetchHandlerForm({
            method: "POST",
            endpoint: `/vendor/${slugname}/products`,
            formData: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdateVendor = async (slugname, data, id) => {
    try {
        const response = await fetchHandlerForm({
            method: "PUT",
            endpoint: `/vendor/${slugname}/product/${id}`,
            formData: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdatestatusVendor = async (slugname, data, id) => {
    try {

        const response = await fetchHandler({
            method: "PUT",
            endpoint: `/vendor/${slugname}/products/status/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GETSingleVendor = async (slugname, id) => {
    try {
        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/products/${id}`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GETVendor = async (slugname) => {
    try {
        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/products/`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const DELETEPoduct = async (slugname, id) => {
    try {
        const response = await fetchHandler({
            method: "DELETE",
            endpoint: `/vendor/${slugname}/products/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
